import { createContext } from 'react';
import { TransformedCorporateFields } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/utils/corporateFields.utilities';

export interface CorporateFieldsContextType {
  corpFieldsData: TransformedCorporateFields;
  loading: boolean;
}

export const CorporateFieldsContext =
  createContext<CorporateFieldsContextType | null>(null);
